// pages/PatientMessagesPage.js
import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import MessagesContent from '../../components/MessagesContent';

const PatientMessagesPage = () => {
  return (
    <DashboardLayout helpText="">
      <MessagesContent 
        userRole="patient"
        nameField="doctor"
        specialtyField="specialization"
        useBackNav={true}
        useChatHeader={true}
        avatarInitial="D"
        messageColor="red"
        replyColor="green"
      />
    </DashboardLayout>
  );
};

export default PatientMessagesPage;